import checkout from "./form";

const {
  formField: {
    taxCalculationPeriod,
    firstTime,
    supplementaryForThe,
    taxId,
    orgName,
    taxId2,
    address,
    contract,
    contractNumber,
    contractNumberDate,
    orgName2,
    address2,
    taxId3,
    taxId4,
    checkbox1,
    checkbox2,
    taxId5,
    orgName3,
    taxId6,
    address3,
    contract2,
    moneyType,

    fullName,
    certificate,
    signer,
    timeSign,
  },
} = checkout;

const initialValues = {
  [orgName.name]: "",
  [fullName.name]: "",
  [contractNumber.name]: "",
  [contractNumberDate.name]: "",
  [orgName2.name]: "",
  [address2.name]: "",
  [taxId4.name]: "",
  [taxId5.name]: "",
  [orgName3.name]: "",
  [taxId6.name]: "",
  [address3.name]: "",
  [contract2.name]: "",
  [address.name]: "",
  [certificate.name]: "",
  [signer.name]: "",
  [timeSign.name]: "",
  [checkbox1.name]: false,
  [checkbox2.name]: false,
  [taxCalculationPeriod.name]: "",
  [firstTime.name]: false,
  [supplementaryForThe.name]: "",
  [taxId.name]: "",
  [contract.name]: "",
  [checkbox1.name]: false,
  [checkbox2.name]: false,
  [taxId2.name]: "",
  [taxId3.name]: "",
  [moneyType.name]: "",
};

export default initialValues;
